import { Activity, Program } from '@citruscamps/citrus-client'
import { DateTime } from 'luxon'
import React from 'react'
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary'
import { Tooltip } from '../Tooltip/Tooltip'
import { TruncatedText } from '../TruncatedText/TruncatedText'
import { ActivityText } from './ActivityText'
import { DefaultActivityText } from './DefaultActivityText'
import { isSupportedActivity } from './types/ActivityEvent'

interface IProps {
  relative?: boolean
  activity: Activity
  program: Pick<Program, 'id' | 'name'>
}

export const ActivityRow = ({ activity, program, relative }: IProps) => (
  <>
    <TruncatedText lines={3}>
      <ErrorBoundary ErrorView={() => <DefaultActivityText activity={activity} />}>
        {isSupportedActivity(activity) && <ActivityText activity={activity} program={program} />}
        {!isSupportedActivity(activity) && <DefaultActivityText activity={activity} />}
      </ErrorBoundary>
    </TruncatedText>
    <div className="small text-body-secondary">
      {typeof relative === 'undefined' || relative === true ? (
        <Tooltip
          title={DateTime.fromJSDate(new Date(activity.created)).toLocaleString(DateTime.DATE_FULL)}
          placement="right"
          popupProps={{ style: { zIndex: 1090 } }}
        >
          {DateTime.fromJSDate(new Date(activity.created)).toRelative()}
        </Tooltip>
      ) : (
        DateTime.fromJSDate(new Date(activity.created)).toLocaleString(DateTime.TIME_SIMPLE)
      )}
    </div>
  </>
)
